<template>
  <div class="relative" v-bind="$attrs">
    <div class="absolute pointer-events-none top-0 left-0">
      <svg
        :width="viewBoxWidth"
        :height="viewBoxHeight"
        :viewBox="`0 0 ${viewBoxWidth} ${viewBoxHeight}`"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color: #ffffff; stop-opacity: 0.33" />
            <stop offset="41%" style="stop-color: #ffffff; stop-opacity: 0" />
            <stop offset="57%" style="stop-color: #ffffff; stop-opacity: 0" />
            <stop offset="100%" style="stop-color: #ffffff; stop-opacity: 0.1" />
          </linearGradient>
        </defs>
        <rect
          :x="borderThickness / 2"
          :y="borderThickness / 2"
          :rx="computedBorderRadius"
          :ry="computedBorderRadius"
          :width="Math.max(viewBoxWidth - borderThickness, 0)"
          :height="Math.max(viewBoxHeight - borderThickness, 0)"
          fill="#7B7B7B28"
          stroke="url(#gradient)"
          :stroke-width="borderThickness"
          vector-effect="non-scaling-stroke"
        />
      </svg>
    </div>
    <div ref="sizeTarget" class="flex-col z-10">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  borderThickness: {
    type: Number,
    default: 2,
  },
  borderRadius: {
    type: String,
    default: '1',
  },
})

defineOptions({
  inheritAttrs: true,
})

const sizeTarget = ref<HTMLDivElement | null>(null)

const viewBoxWidth = ref(0)
const viewBoxHeight = ref(0)
let observer: ResizeObserver | null = null

// border radius is in rem, so convert from rem to px
// this is necessary due svg not supporting rem units
const computedBorderRadius = computed(() => {
  return parseFloat(props.borderRadius) * parseFloat(getComputedStyle(document.documentElement).fontSize)
})

onMounted(() => {
  nextTick(() => {
    if (sizeTarget.value !== null) {
      observer = new ResizeObserver(() => {
        const { width, height } = sizeTarget.value?.getBoundingClientRect() ?? { width: 0, height: 0 }
        viewBoxWidth.value = width
        viewBoxHeight.value = height
      })
      observer.observe(sizeTarget.value)
    }
  })
})

onBeforeUnmount(() => observer?.disconnect())
</script>
